<section class="widget-container" [class.widget-container--drilldown]="hasFilters">
  <!-- eCharts Component -->
  <div echarts [options]="echartOptions"></div>
  <div *ngIf="hasFilters" class="drilldown-panel">
    <button
      type="button"
      *ngFor="let filterOption of widgetConfig.widgetFilters[0].filterOptions"
      (click)="updateWidgetFilter(widgetConfig.widgetFilters[0].filterId, filterOption.id)"
      [class.active]="widgetConfig.widgetFilters[0].filterSelection === filterOption.id">
      <span #sidePanelButtonText>{{ filterOption.name }}</span>
    </button>
  </div>
</section>
